import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'VirtualWarehouse',
    column_type: 'id',
    label_key_path: 'virtualWarehouse.id',
  },
  created_at: {
    model_name: 'VirtualWarehouse',
    column_type: 'datetime',
    label_key_path: 'virtualWarehouse.createdAt',
  },
  updated_at: {
    model_name: 'VirtualWarehouse',
    column_type: 'datetime',
    label_key_path: 'virtualWarehouse.updatedAt',
  },
  name: {
    model_name: 'VirtualWarehouse',
    column_type: 'string',
    label_key_path: 'virtualWarehouse.name',
  },
  jushuitan_id: {
    model_name: 'VirtualWarehouse',
    column_type: 'integer',
    label_key_path: 'virtualWarehouse.jushuitanId',
  },
  disabled: {
    model_name: 'VirtualWarehouse',
    column_type: 'boolean',
    label_key_path: 'virtualWarehouse.disabled',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
